import(/* webpackMode: "eager" */ "/home/runner/work/apollo/apollo/apps/healthcare.com/src/app/global-error.tsx");
